import ContentEntity from './content-entity.js';

/**
 * BlogEntity — one blog post (/blog + /blog/:slug).
 * Absorbs the old normalizeBlog/isBlogActive helpers from blog-data.js.
 */
class BlogEntity extends ContentEntity {
    static TYPE = 'blogs';
    static S3_PATH = 'content.blogsData';

    static EMPTY = {
        id: '',
        status: true,
        slug: '',
        language: 'en',
        title: '',
        subtitle: '',
        author: '',
        heroImage: '',
        image: '',
        seo: { title: '', description: '', keywords: '', image: '', ogImage: '' },
        intro: '',
        sections: [],
        tags: [],
        publishedAt: '',
        updatedAt: '',
        source: 'local',
        externalId: null,
    };

    constructor(raw = {}) {
        super(raw);

        if (!raw.heroImage && !raw.image && !raw.media && !raw.seo?.ogImage && !raw.seo?.image) {
            console.warn('Blog missing any image:', raw.slug || raw.id);
        }

        this.author = raw.author || raw.generatedBy || null;
        // Convenience: one field every card/list can rely on for the cover.
        const R = BlogEntity.resolveImg;
        this.cover = R(raw.heroImage) || R(raw.image) || R(raw.media) || R(raw.seo?.ogImage) || R(raw.seo?.image) || null;
    }
}

export default BlogEntity;
